import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { useStoreStyles } from "./useStoreStyles";
import logo from "../../assets/images/webappLogo.jpg";
import { useStore } from "../../store";
import { Helmet } from "react-helmet-async";
import { number } from "yup";

export const StoreDetails = () => {
  const classes = useStoreStyles();
  const [storeDetails] = useStore("storeDetails");
  const [division] = useStore("division");

  const foundedDivisionData =
    division &&
    division.find((item: any) => item.id === storeDetails?.division_id);

  return (
    <>
      <Helmet>
        <title>Store</title>
      </Helmet>
      <Grid container spacing={2} direction="row">
        <Grid item xs={12}>
          <Grid container>
            <img src={logo} alt="Logo" />
            <Typography className={classes.companyTitle}>
              {storeDetails !== undefined ? storeDetails.name : ""}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.mainGridStyle}>
          <Paper className={classes.paper}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        Store Code
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {storeDetails !== undefined ? storeDetails.code : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        Division{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {storeDetails && foundedDivisionData
                          ? foundedDivisionData.name
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        PLH Code{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {storeDetails !== undefined
                          ? storeDetails.plh_code
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.textStyles}>
                        Validate Stock{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography className={classes.textStyles}>:</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container justify="flex-start">
                      <Typography className={classes.valueStyles}>
                        {storeDetails !== undefined
                          ? storeDetails.validate_stock !== "Y"
                            ? "No"
                            : "Yes"
                          : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};
